<div class="text-justify" tabindex="0">
  <!-- <div *ngIf="modalType===modalDialogType.confirm"> -->


  <div class="modal-header m-transparent">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-header m-gray-back text-center d-flex align-items-center justify-content-center">
    <img src="assets/images/new-logo.png" class="m-logo" alt="{{'COMMON.LOGO_ALT' | translate}}" />
  </div>
  <div class="modal-body text-center d-flex align-items-center justify-content-center">
    <strong [innerHTML]='msg'></strong>
    <!-- <p><strong>תודה על פנייתך<br>בנקאי יחזור אליך בהקדם</strong></p> -->
  </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/modal-window/modal-window.component.html